export default "<div [innerHTML]=\"content\" *ngIf=\"content\"></div>\r\n"